import type { PropertySchema } from '@takeshape/schema';
import last from 'lodash/last';
import memoize from 'lodash/memoize';
import type { ImmutableMap } from '../../common/utils/immutable-types';
import type { ResolveRef } from '../types';

export function refToPath(ref: string): string[] {
  return ref.substr(2).split('/');
}

function patchSchema(
  root: ImmutableMap<PropertySchema>,
  schema: ImmutableMap<PropertySchema>
): ImmutableMap<PropertySchema> {
  const path = refToPath(schema.get('$ref'));
  const referencedSchema = root.getIn<ImmutableMap<PropertySchema>>(path);
  return referencedSchema ? referencedSchema.merge(schema.remove('$ref')) : schema;
}

export function createResolveRef(rootSchema: ImmutableMap<PropertySchema>): ResolveRef {
  return memoize((schema: ImmutableMap<PropertySchema>): ImmutableMap<PropertySchema> => {
    if (schema.get('$ref')) {
      return patchSchema(rootSchema, schema);
    }

    return schema;
  });
}

export function splitRef(ref?: string): string[] {
  const parts = ref ? ref.split('/') : [];
  return parts[0] === '#' ? parts.slice(1) : parts;
}

export function parseRef($ref: string) {
  const schemaPath = splitRef($ref);
  return { typeName: last(schemaPath), schemaPath };
}
